import { Component, OnInit } from '@angular/core';
// @ts-ignore
// import SwaggerUI from 'swagger-ui';
import {RestBackendService} from "../service/rest-backend.service";
import {template} from "suneditor/src/plugins";
import {TemplateComponent} from "../dashbord/template/template.component";

@Component({
  selector: 'app-api-docs',
  templateUrl: './api-docs.component.html',
  styleUrls: ['./api-docs.component.css']
})
export class ApiDocsComponent extends TemplateComponent implements OnInit {


  ngOnInit(): void {
    // SwaggerUI({
    //   domNode: document.getElementById('swagger-ui-item'),
    //   url: this.config.getBaseUrl() +  'doc/apiDoc/api_docs_config',
    //   deepLinking: true,
    // });
  }

}
